var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-fade-transition',{attrs:{"group":""}},[_vm._l((_vm.responses),function(response){return [_c('w-list-item',{key:response.__uid__,attrs:{"item":response,"auto-reduce":""}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }